import { render, staticRenderFns } from "./global-options-partial.vue?vue&type=template&id=b3e4c0ec"
import script from "./global-options-partial.vue?vue&type=script&lang=js"
export * from "./global-options-partial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports